module.exports = __webpack_public_path__ + "static/img/clothing_04.8341686.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_04.png
// module id = 7CeK
// module chunks = 0